<template>
  <section class="rank-content">
    <div class="main">
      <div class="second">
        <span class="main-title">{{rank_main_title_}}</span>
         <ul class="table" v-if="result && result.length">
            <li class="thead">
              <a>
                <span>{{rank_}}</span>
                <span>{{team_}}</span>
                <!--<span>{{location_}}</span>-->
                <span>{{score_}}</span>
                <span>{{solved_}}</span>
                <span>{{finishedTime_}}</span>
              </a>
            </li>
            <li class="tr" v-for="(r, index) in result" :key='index'>
              <router-link :id="'rank_'+r.tid" :to="r.tid && '/team/'+ r.tid || ''">
                <span>{{index + 1}}</span>
                <span :title="r.name" class="name_logo">
                  <img :src="r.logo" alt="" /> {{r.name}}
                </span>
                <!--<span v-if="r.country" class="country_logo"><img :title="getcn(r.country)" :src="'flags/'+r.country.toLowerCase()+'.png'" :alt="getcn(r.country)" /></span>-->
                <!--<span v-if="!r.country">N/A</span>-->
                <span>{{r.rating}}</span>
                <span>{{r.num_solved}}</span>
                <span>{{formatTime(r.last_solve_time)}}</span>
              </router-link>
            </li>
          </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import { formatTime } from '@/utils'
import { getCountryName } from '@/utils/country.js'
import { rank } from '@/utils/api.js'
import i18n from '@/i18n'
import bus from '@/utils/event_bus.js'

// let teams = null

export default {
  data () {
    return {
      result: []
    }
  },
  computed: {
    ...mapState(['v_locale']),
    ...mapGetters([]),
    ...i18n.map([
      'rank_main_title_',
      'rank_',
      'team_',
      'location_',
      'score_',
      'solved_',
      'finishedTime_'
    ])
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
    formatTime,
    getcn: getCountryName,
    init () {
      rank()
        .then(data => {
          const arr = data.data
          // Doesn't seems to be useful
          // if (!teams) {
          //   const teamDict = {}
          //   for (let i of arr) {
          //     i.last_solve_time = Date.parse_iso(i.last_solve_time)
          //     teamDict[i.tid] = i.name
          //   }
          //   teams = teamDict
          // }
          this.result = arr
        })
        .catch(err => {
          this.$emit('msg', {
            msg: err.message,
            type: 'error',
            delay: 2000
          })
        })
    }
  },
  created () {
    this.init()
    bus.$on('UPDATE', this.init)
  },
  beforeDestroy () {
    bus.$off('UPDATE', this.init)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/rank.vue